module.exports = __webpack_public_path__ + "img/chevron-left.b1407d67.svg";